import styled from 'styled-components';
import media from '../../../../constants/media';
import theme from '../../../../constants/theme';
import Button from '../../../base/button';

export const AcceptedTrackingNumbers = styled.div`
	display: flex;
	margin: 2rem 0;
	flex-wrap: wrap;
	${media.mobileAndTabletOnly`
		flex-direction: column;`}
`;

export const AcceptedTrackingNumber = styled.div`
	border-radius: 1rem;
	box-shadow: 0 0 40px 0.1rem #00000014;
	padding: 1rem;
	padding-left: 2rem;
	margin-right: 2rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-right: 1rem;
	margin-top: 1rem;
	p {
		margin-bottom: 0;
	}
	svg {
		margin-left: 1rem;
		width: 2rem;
		height: 2rem;
		top: 1rem;
		cursor: pointer;
		color: ${theme.colors.primary};
	}
`;

export const InputWrapper = styled.div`
	display: flex;
	gap: 1rem;
	margin-top: 3rem;

	${media.mobileAndTabletOnly`
		flex-direction: column;
	`}
`;

export const AddButton = styled(Button)`
	background: transparent;
	border: 1px solid ${theme.colors.primary};
	color: ${theme.colors.primary};
	border-radius: 1rem;
`;
